import { deleteDoc, getDoc, getDropdownList, saveDoc } from '../apiCommon';
import { TAX_EXEMPT_TYPE } from '../../constants/constant_doc_types';

export const saveTaxExemptType = (app, dataToSave) => {
  const { user = {}, data } = dataToSave;
  const doc = {
    active: data.active,
    doc_type: TAX_EXEMPT_TYPE,
    name: data.name,
    short_name: data.short_name,
    system_defined: data.system_defined,
  };

  return saveDoc(app, {
    doc,
    user,
    source: data,
  });
};

export const fetchTaxExemptTypeDropdown = (app, params) => {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = `${TAX_EXEMPT_TYPE}/dropdown`;
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return getDropdownList(app, { query });
};

export const deleteTaxExemptType = (app, data) =>
  deleteDoc(app, {
    id: data.id,
    docType: TAX_EXEMPT_TYPE,
  });

export const fetchTaxExemptTypeById = (app, params) => {
  const { id } = params;
  const docType = TAX_EXEMPT_TYPE;

  return getDoc(app, { id, docType });
};
